export function emptyContractForm() {
  return {
    number: '',
    quantity: '',
    price_per_unit: '',
    amount: '',
    start_date: new Date().toISOString().slice(0, 10),
    end_date: new Date(Date.now() + 30 * 86400000).toISOString().slice(0, 10),
    progress: '',
  };
}

export function contractToForm(contract) {
  if (!contract) return emptyContractForm();
  return {
    number: contract.number || '',
    quantity: String(contract.quantity ?? ''),
    price_per_unit: String(contract.price_per_unit ?? ''),
    amount: String(contract.amount ?? ''),
    start_date: contract.start_date || '',
    end_date: contract.end_date || '',
    progress: contract.progress != null ? String(contract.progress) : '',
  };
}

export function updateContractFormField(form, field, value) {
  const next = { ...form, [field]: value };
  if (field === 'quantity' || field === 'price_per_unit') {
    const qty = parseFloat(next.quantity) || 0;
    const price = parseFloat(next.price_per_unit) || 0;
    if (qty && price) next.amount = (qty * price).toFixed(2);
  }
  if (field === 'amount') {
    const qty = parseFloat(next.quantity) || 0;
    const amount = parseFloat(next.amount) || 0;
    if (qty && amount && field === 'amount') {
      next.price_per_unit = (amount / qty).toFixed(2);
    }
  }
  return next;
}

export function buildContractPayload(form, { includeProgress = false, productId } = {}) {
  const qty = parseInt(form.quantity, 10);
  const price = parseFloat(form.price_per_unit);
  const amount = parseFloat(form.amount) || qty * price;
  const payload = {
    number: form.number.trim(),
    quantity: qty,
    price_per_unit: price.toFixed(2),
    amount: amount.toFixed(2),
    start_date: form.start_date,
    end_date: form.end_date,
  };
  if (productId) payload.product = parseInt(productId, 10);
  if (includeProgress && form.progress !== '') {
    payload.progress = Math.min(100, Math.max(0, parseInt(form.progress, 10) || 0));
  }
  return payload;
}
